import { render, staticRenderFns } from "./ele1.vue?vue&type=template&id=4a0f5a6a&scoped=true"
import script from "./ele1.vue?vue&type=script&lang=js"
export * from "./ele1.vue?vue&type=script&lang=js"
import style0 from "./ele1.vue?vue&type=style&index=0&id=4a0f5a6a&prod&lang=scss"
import style1 from "./ele1.vue?vue&type=style&index=1&id=4a0f5a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f5a6a",
  null
  
)

export default component.exports